import { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useParams } from 'react-router-dom'
import { Wallpaper } from '../../components/Wallpaper'
import * as S from './styles'
import { setDatadogPageAction } from '../../services/datadog'
import { NotFoundPage } from '../NotFoundPage'
import { ValueNoneIcon } from '@radix-ui/react-icons'
import { styled } from '../../modules';
import { useThemeContext } from '../../contexts/ThemeContext'

export const RedirectContainer = () => {
    const { signerHash } = useParams()
    const { setClientThemeSettings } = useThemeContext();

    const [response, setResponse] = useState({
        status: 'loading',
    } as {
        status: 'loading' | 'not_found' | 'network_failed' | 'unhandled_error' | 'success'
        data?: any
    });

    useEffect(() => {
        setDatadogPageAction(`/r/${signerHash}`, {
            signerHash,
        })
    }, [signerHash])

    useEffect(() => {
        getThemeByHash(signerHash).then((response) => {
            setResponse(response)
            setClientThemeSettings(response?.data?.client || undefined)
        })
    }, [signerHash, setClientThemeSettings])


    if (response.status === 'loading') {
        return (
            <Wallpaper backgroundColor="#0E3573">
                <S.Card className="base-container-width base-container-padding">
                    <S.Text>
                        <b>Carregando Informações...</b>
                    </S.Text>
                </S.Card>
            </Wallpaper>
        )
    }

    if (response.status === 'not_found') {
        return (
            <NotFoundPage />
        )
    }

    if (response.status === 'network_failed') {
        return (
            <Wallpaper backgroundColor="#0E3573">
                <S.Card className="base-container-width base-container-padding">
                    <ValueNoneIcon color="#D13415" style={{ marginBottom: '8px', width: '28px', height: '28px' }} />
                    <S.Text style={{ marginBottom: '16px' }}>
                        <b style={{ fontSize: '18px' }}>Erro de conexão</b>
                    </S.Text>
                    <S.Text>
                        Não foi possível se conectar com o servidor. Por favor, verifique sua conexão de internet e tente novamente.
                    </S.Text>
                </S.Card>
            </Wallpaper>
        )
    }

    if (response.status === 'unhandled_error') {
        return (
            <Wallpaper backgroundColor="#0E3573">
                <S.Card className="base-container-width base-container-padding">
                    <S.Text>
                        <b>Ocorreu um erro</b>
                    </S.Text>
                    <S.Text>
                        Um erro inesperado ocorreu ao carregar as informações. Por favor, tente novamente mais tarde.
                    </S.Text>
                </S.Card>
            </Wallpaper>
        )
    }

    const Button = styled(Link)`
        padding: 8px 8px;
        margin-bottom: 20px;
        border-radius: 8px;
        color: white;
        background-color: ${response.data?.client?.button_color ?? '#4FCCED'};
        font-size: 13px;
        width: 90%;
        font-weight: 600;
        text-align: center;
        line-height: 24px;
        letter-spacing: 0.5px;
        cursor: pointer;
    `;

    const Content = styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin-bottom: 16px;
        border-radius: 20px 0;
    `;

    return response.data?.client?.custom_initial_step_image_url?
        (
            <Wallpaper backgroundColor={response.data?.client?.background_color}>
                <S.Card>
                    <Content>
                        <img className='custom-redirect-container' style={{borderTopLeftRadius: '20px', borderTopRightRadius: '20px', maxHeight: '80vh'}} src={response.data?.client?.custom_initial_step_image_url} alt="initial step" />
                    </Content>
                    <Button
                        to={`/s/${signerHash}`}
                    >
                        CONTINUAR
                    </Button>
                </S.Card>
            </Wallpaper>
        )
        : (
            <Wallpaper backgroundColor={response.data?.default?.background_color}>
                <S.Card className="base-container-width base-container-padding">
                    <S.Header>
                        <S.Logo src={response.data?.default?.logo_url} />
                        <S.UpdateIcon />
                        <S.Logo src={response.data?.client?.logo_url} style={{ marginTop: '8px' }} />
                    </S.Header>
                    <S.Content>
                        <S.Text>
                            Olá <b>{response.data?.signer_name}</b>,
                        </S.Text>
                        <S.Text>
                            Para seguir com o empréstimo da carteira de trabalho digital, você será redirecionado para a tela do nosso parceiro, <b>{response.data?.client_name}</b>.
                            Clique em "Continuar" para seguir.
                        </S.Text>
                        <S.Text style={{ textAlign: 'left' }}>

                        </S.Text>
                    </S.Content>
                    <S.Button
                        onClick={() => { window.location.href = window.location.href.replace('/r', '/s') }}
                    >
                        CONTINUAR
                    </S.Button>
                </S.Card>
            </Wallpaper>
        );
}

const getThemeByHash = async (signerHash: string): Promise<{
    status: 'loading' | 'not_found' | 'network_failed' | 'unhandled_error' | 'success'
    data?: any
}> => {
    const defaultTheme = {
        logo_url: "https://qisign-app-production.s3.amazonaws.com/logos/qi_tech_azul_claro_escuro_principal.png",
        font_color: "#000000",
        button_color: "#4FCCED",
        email_logo_url: "https://qisign-app-production.s3.amazonaws.com/logos/qi_tech_branco_email.png",
        background_color: "#0E3573"
    }

    try {
        const response = await axios.get('/signer/hash/' + signerHash)
        console.log("Response: ", response.data)
        return {
            status: 'success',
            data: {
                client_name: response.data.signer_company_name ?? '',
                client: response.data.client_theme_settings,
                default: defaultTheme,
                signer_name: response.data.signer_data.name,
            }
        }
    } catch (error) {
        console.log("Error: ", error)
        if (error.status === 404 || error.status === 401) {
            return {
                status: 'not_found'
            }
        }
        if (error.status === undefined) {
            return {
                status: 'network_failed'
            }
        }
        return {
            status: 'unhandled_error'
        }
    }
}